import { LINKS } from '@trip-ux/constants';
import axios from 'axios';
import { get } from 'lodash';
import { ReduxStore } from '../payload-types';
import { fork, select, call, take, put } from 'redux-saga/effects';
import { EXTRNL_REPORT_ORGANIZATION_SEARCH, EXTRNL_REPORT_ORGANIZATION_SEARCH_RESULT } from './types';
import { sortArray } from '../utils';

const getReportOrganizationList = (state: ReduxStore, payload) =>
  axios
    .post(`${get(state, 'config.options.contextPath', '')}${LINKS.EXTRNL_REPORT_ORG_LIST}`, payload, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(res => get(res, 'data', []))
    .catch(() => []);

function* watchReportOrganizationSearchRequest() {
  while (true) {
    const { payload } = yield take(EXTRNL_REPORT_ORGANIZATION_SEARCH);
    const state: ReduxStore = yield select((store: ReduxStore) => store);
    const organizations = yield call(getReportOrganizationList, state, payload);
    const sortedOrganizations = sortArray(organizations, state.config.locale);
    yield put({ type: EXTRNL_REPORT_ORGANIZATION_SEARCH_RESULT, payload: sortedOrganizations });
  }
}

export default [fork(watchReportOrganizationSearchRequest)];
